import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GroupType, Permission } from 'src/app/core/enums/enums';
import { IRole, IUser } from 'src/app/core/models/User';
import { ServicesService } from 'src/app/core/services/services.service';
import { SessionService } from 'src/app/core/services/session.service';
import { OptionObject } from 'src/app/core/utils/type';

@Component({
  selector: 'app-global-dropdown',
  templateUrl: './global-dropdown.component.html',
  styleUrls: ['./global-dropdown.component.scss'],
})
export class GlobalDropdownComponent implements OnInit, OnDestroy {
  @ViewChild('dropdownTrigger', { static: true }) dropdownTrigger!: ElementRef;
  @ViewChild('dropdown', { static: true }) dropdown!: ElementRef;
  isOpen: boolean = false;
  @Input() options!: OptionObject[];
  @Input() classNames: string = '';
  @Output() triggerEvent: EventEmitter<any> = new EventEmitter();
  @Input() pickValue?: OptionObject;
  @Input() optionWidth?: 'w-60' | 'w-75';
  @Input() caller = '_GLOBAL';
  @Input() backdrop = false;
  @Input() formRight = false;
  _role_selected!: IRole;
  user!: IUser;
  groupType = GroupType;
  $countrybind!: Subscription;
  widthMatches = [
    { width: 240, match: 'w-60' },
    { width: 300, match: 'w-75' },
  ];
  screenWidth!: number;

  /*@HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    this.screenWidth = window.innerWidth;
    if (this.isOpen) this.setDialogPosition();
  }*/

  constructor(
    private sessionService: SessionService,
    private services: ServicesService,
    private renderer: Renderer2,
  ) {
    //this.onResize();
  }

  ngOnDestroy(): void {
    if (this.$countrybind) this.$countrybind.unsubscribe();
  }

  ngOnInit(): void {
    this.user = this.sessionService.getUser();
    if (this.options.length > 0) this.pickValue = this.options[0];
    this.triggerEvent.emit(this.pickValue);
    this.$countrybind = this.services.eventService.subscribe(
      'map:bindcountry',
      (data: OptionObject) => {
        this.pickValue = data;
      },
    );
  }

  isGroupOwer(option: OptionObject): boolean {
    this.user = this.sessionService.getUser();
    if (
      this._role_selected &&
      this._role_selected.permissions?.length === 0 &&
      this.user.admin_type &&
      this.user.admin_type === 'admin'
    )
      return true;
    this._role_selected = this.user.roles!.find((role) => role.id == Number(option.value))!;
    return this._role_selected.permissions?.includes(Permission.Owner);
  }

  selectedOption(option: OptionObject): void {
    if (option.value != '_ADD_GROUP') {
      this.pickValue = option;
      this.triggerEvent.emit(option);
      this.isOpen = false;
    } else {
      this.handleGroupActions('_CREATE_GROUP', option);
    }
  }

  getRoleName(option: OptionObject): string {
    let role!: IRole;
    if (option.value != 'admin')
      role = this.user.roles!.find((role) => role.id == Number(option.value))!;
    return role ? role.group.type : '';
  }

  setDialogPosition(): void {
    const target_1: ElementRef = new ElementRef(document.getElementById('dropdownTrigger'));
    const dropdown: ElementRef = new ElementRef(document.getElementById('dropdown'));
    if (target_1.nativeElement) {
      const dropdownWidth = this.optionWidth ? this.getCustomWidth() : 300;
      const rect = target_1.nativeElement.getBoundingClientRect();
      const position = {
        top: rect.top + window.pageYOffset,
        left: rect.left + window.pageXOffset,
      };

      console.log('Element position:', position);
      console.log(rect);
      console.log('screenWidth', this.screenWidth);
      const rightGouter = this.screenWidth - rect.right;
      console.log('rightGouter', rightGouter);
      let targetWidth = target_1.nativeElement.offsetWidth;
      if (targetWidth + rightGouter < dropdownWidth) {
        const right = dropdownWidth - (targetWidth + rightGouter);
        dropdown.nativeElement.style = `right:${right}px`;
      } else {
        dropdown.nativeElement.style = `left:0`;
      }
    }
  }

  getCustomWidth(): number {
    return this.widthMatches.find((w) => w.match === this.optionWidth)?.width!;
  }

  clickedOutside(): void {
    this.isOpen = false;
  }

  openfilterSelect(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.triggerEvent.emit('open');
      /*setTimeout(() => this.setDialogPosition(), 1000);*/
    }
  }

  handleGroupActions(action: '_CREATE_GROUP' | '_EDIT_GROUP', pickValue: OptionObject): void {
    this.triggerEvent.emit({ action: action, data: pickValue });
    this.isOpen = false;
  }

  close(): void {
    this.isOpen = false;
  }

  clear(): void {}
}
